import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatusChip } from 'Components/common/StatusChip'

const MATURITY_VARIANT = {
  'Initial': 'maturity-initial',
  'Developing': 'maturity-developing',
  'Defined': 'maturity-defined',
  'Managed': 'maturity-managed',
  'Optimized': 'maturity-optimized',
}

const MATURITY_KEYS = {
  'Initial': 'initial',
  'Developing': 'developing',
  'Defined': 'defined',
  'Managed': 'managed',
  'Optimized': 'optimized',
}

export const MaturityBadge = ({ label }) => {
  const { t } = useTranslation('transparency')
  if (!label) return null
  const variant = MATURITY_VARIANT[label]
  const key = MATURITY_KEYS[label]
  const displayLabel = key ? t(`shared.maturity.${key}`) : label

  return <StatusChip label={displayLabel} variant={variant} />
}
